import { useCallback, useState } from 'react'

import type { FinancialMetricMode } from 'partner360/entities/financialMetricMode'

import { confirmTnetReview } from '../api/confirmTnetReview'

type ConfirmReviewParams = {
  partnerId: string
  fYear: number
  programType: string
  category: string | null
  reviewMetricMode: FinancialMetricMode
}

export const useConfirmTnetReview = () => {
  const [isConfirmingReview, setIsConfirmingReview] = useState(false)
  const [hasConfirmReviewError, setHasConfirmReviewError] = useState(false)

  const handleConfirmReview = useCallback(async (params: ConfirmReviewParams) => {
    setHasConfirmReviewError(false)
    setIsConfirmingReview(true)

    try {
      await confirmTnetReview(params)
      return true
    } catch {
      setHasConfirmReviewError(true)
      return false
    } finally {
      setIsConfirmingReview(false)
    }
  }, [])

  return {
    confirmReview: handleConfirmReview,
    isConfirmingReview,
    hasConfirmReviewError,
  }
}
